import { Component } from '@angular/core';

@Component({
  selector: 'app-future-percentage-info',
  templateUrl: './future-percentage-info.component.html',
  styleUrls: ['./future-percentage-info.component.scss']
})
export class FuturePercentageInfoComponent {

}
